export const isDateValid = (date: Date) => {
  if (Object.prototype.toString.call(date) === '[object Date]') {
    // it is a date
    if (isNaN(date.getTime())) {
      // date object is not valid
      return false
    } else {
      return true
      // date object is valid
    }
  }
  // not a date object
  return false
}
